export default __webpack_public_path__ + "static/media/exito2.ac95afb2.png";